module.exports = __webpack_public_path__ + "img/icon-polygon2.72d97fc7.svg";